import EmbeddedAuthForm, { type View } from './EmbeddedAuthForm';

export default EmbeddedAuthForm;
export type { View };
